import React from 'react';

export interface LoaderTheme {
  primary?: string;
  secondary?: string;
}

export const LoaderIcon: React.FC = () => {
  return (
    <div className="w-4 h-4 box-border border-2 border-solid rounded-full border-neutral-200  border-r-neutral-400	animate-spin"></div>
  );
};
